import {
    fetchMonitoringEvent
} from '../../../services/api/monitoring'
import { naturalCompare } from '../../../helpers'

export const monitoringSubject = {
    namespaced: true,
    state: {
        display: 10,
        page: 1,
        sort: {
            column: 'date',
            order: 'desc'
        },
        subject: null,
        count: 0,
        pending: false,
        events: [],
        selectedTab: "credits"
    },
    mutations: {
        save(state, data) {
            state.subject = data;
            state.events = data.monitoringEvents;
            state.selectedTab = "credits";
            state.count = data.count;
        },
        setPage(state, page) {
            state.page = page
        },
        setSort(state, sort) {
            state.sort = sort
        },
        resetState(state) {
            state.page = 1
            state.subject = null
        },
        setPending(state, bool) {
            state.pending = bool
        },
        selectTab(state, tab) {
            state.selectedTab = tab
        }
    },
    actions: {
        fetchSubject({ commit, dispatch }, id) {
            commit('setPending', true);
            return fetchMonitoringEvent(id)
                .then(res => {
                    commit('save', res.data)
                    return res
                })
                .catch(res => {
                    dispatch('error', res, { root: true })
                    throw res
                })
        },
        reset({ commit }) {
            commit('resetState');
        },
        setSort({ commit }, sort) {
            commit('setSort', sort)
        },
        selectTab({ commit }, tab) {
            commit('selectTab', tab)
        }
    },
    getters: {
        filteredRecords({ events, selectedTab }) {
            if (!selectedTab) {
                return events
            }
            return events.filter(event => {

                if (selectedTab === 'credits') {
                    return event.credit.limit && event.code !== '15'
                }

                if (selectedTab === 'inquiries') {
                    return event.inquiry.purposeName
                }

                if (selectedTab === 'bankrupts') {
                    return event.code === '23'
                }

                if (selectedTab === 'applications') {
                    return ['100', '101', '102', '103', '104', '105'].includes(event.code)
                }

                if (selectedTab === "prohibitions"){
                    return event.code === '106'
                }
            });
        },
        sortedRecords({ sort, selectedTab }, { filteredRecords }) {
            
            const sorted = filteredRecords.sort((a, b) => {

                let thisA = a[sort.column];
                let thisB = b[sort.column];

                if (selectedTab === 'credits') {
                    thisA = a.credit[sort.column];
                    thisB = b.credit[sort.column];
                }

                if (selectedTab === 'inquiries') {
                    thisA = a.inquiry[sort.column];
                    thisB = b.inquiry[sort.column];
                }

                if (selectedTab === 'bankrupts') {
                    thisA = a.bankrupt[sort.column];
                    thisB = b.bankrupt[sort.column];
                }

                if (selectedTab === 'applications') {
                    thisA = a.application[sort.column];
                    thisB = b.application[sort.column];
                }
                
                
                if (selectedTab === 'prohibitions') {
                    thisA = a.prohibition[sort.column];
                    thisB = b.prohibition[sort.column];
                }          

                if (sort.column === "name") {
                    thisA = a[sort.column];
                    thisB = b[sort.column];
                }

                return naturalCompare(
                    !thisA ? "" : thisA,
                    !thisB ? "" : thisB
                )
            })
            return sort.order === 'asc' ? sorted : sorted.reverse()
        },
        events(state, { sortedRecords }) {
            return sortedRecords;
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/modal/ModalMonitoringEvent/store.js